// extracted by mini-css-extract-plugin
export var wrapper = "About-module--wrapper--2GiC4";
export var img = "About-module--img--1IYs9";